import "@babel/polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import VApp from "vuetify/es5/components/VApp";
import Vuetify from "vuetify/es5/components/Vuetify";
import transitions from "vuetify/es5/components/transitions";
import directives from "vuetify/es5/directives";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Marked from "./utils/marked.js";
import "lxgw-wenkai-screen-webfont/style.css";

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	// 路由发生变化修改页面keywords
	if (to.meta.content) {
		let head = document.getElementsByTagName("head")[0]; // 确保获取的是数组中的第一个元素
		let keywordsMeta = document.querySelector('meta[name="keywords"]');
		let descriptionMeta = document.querySelector('meta[name="description"]');

		// 检查并设置 keywords meta 标签
		if (keywordsMeta) {
			keywordsMeta.setAttribute("content", to.meta.content.keywords);
		} else {
			let newKeywordsMeta = document.createElement("meta");
			newKeywordsMeta.setAttribute("name", "keywords");
			newKeywordsMeta.setAttribute("content", to.meta.content.keywords);
			head.appendChild(newKeywordsMeta);
		}

		// 检查并设置 description meta 标签
		if (descriptionMeta) {
			descriptionMeta.setAttribute("content", to.meta.content.description);
		} else {
			let newDescriptionMeta = document.createElement("meta");
			newDescriptionMeta.setAttribute("name", "description");
			newDescriptionMeta.setAttribute("content", to.meta.content.description);
			head.appendChild(newDescriptionMeta);
		}
	}

	next();
});

Vue.config.productionTip = false;
Vue.use(Marked);
Vue.use(Vuetify, {
	components: {
		VApp,
		transitions,
	},
	directives,
});
new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");

// 百度统计

var _hmt = _hmt || [];
(function() {
	var hm = document.createElement("script");
	hm.src = "https://hm.baidu.com/hm.js?9edc375d2f8810b1e0b6a703dab9a022";
	var s = document.getElementsByTagName("script")[0];
	s.parentNode.insertBefore(hm, s);
})();

router.beforeEach((to, from, next) => {
	if (_hmt) {
		if (to.path) {
			_hmt.push(["_trackPageview", "/#" + to.fullPath]);
		}
	}
	next();
});
